export default "__VITE_ASSET__D53emWMR__"